<template>
    <div>
        <main-nav fixed></main-nav>
        <div class="ast-container">
            <img src="https://static.ycsd.work/web/ast_1.png" alt="">
            <img src="https://static.ycsd.work/web/ast_2.png" alt="">
            <img src="https://static.ycsd.work/web/ast_3.png" alt="">
            <img src="https://static.ycsd.work/web/ast_4.png" alt="">
            <img src="https://static.ycsd.work/web/ast_5.png" alt="">
        </div>
        
        <l-footer></l-footer>
        <l-icp></l-icp>
        <l-right-contact></l-right-contact>
    </div>
</template>

<script>
import MainNav from "../../components/MainNav";
import meta from "../../meta";
import LIcp from "../../components/LIcp.vue";
import LFooter from "../../components/LFooter.vue";
import LRightContact from "../../components/LRightContact.vue";

export default {
    name: "AssistantApp",
    components: {LRightContact, LFooter, LIcp, MainNav},
    metaInfo: meta.appendTitle('AI数智美学私域系统'),
    data() {
        return {}
    }
}
</script>

<style lang="less" scoped>
.ast-container {
    line-height: 0;
    img{
        width: 100%;
    }
}
</style>